<template>
  <div class="card shadow-4 h-100">
    <div class="card-body">
      <h3 class="text-danger mb-5 pl-5 text-uppercase">Abonnement</h3>
      <div>
        <div v-if="hasStripePlan" class="d-flex align-items-center mb-5">
          <i class="fas fa-tags" style="flex: 0 0 32px;"></i>
          <span style="line-height: 1.4">
            <span class="mr-2">Abonnement actuel :</span>
            <span :class="(billingPlan == 'BUSINESS' || billingPlan == 'BUSINESS12M') ? 'badge-success' : 'badge-primary'" class="badge px-3 rounded" style="line-height: unset">
              {{ currentPlan.name }}
            </span>
          </span>
        </div>
        <div class="d-flex align-items-center mb-5">
          <i class="fas fa-user-friends" style="flex: 0 0 32px;"></i>
          <span style="line-height: 1.4">
            Votre {{ isTrial ? 'essai' : 'compte' }} Premium est actif pour <b class="text-primary">{{ premiumMaxUsers }} collaborateur{{ premiumMaxUsers > 1 ? 's' : '' }}</b>
            et <b class="text-primary">{{ premiumMaxConsults }} comptes en lecture seule</b>
          </span>
        </div>
        <div v-if="isTrial" class="mt-5">
          <!-- Suspended trial -->
          <div class="d-flex align-items-center">
            <i class="fas fa-credit-card" style="flex: 0 0 32px;"></i>
            <span style="line-height: 1.4">
              Votre essai gratuit
              <b :class="premiumExpireDateIsPast ? 'text-danger' : ''">
                {{ premiumExpireDateIsPast ? 'est arrivé' : 'arrivera' }} à expiration le {{ premiumExpireDate }}
              </b>
            </span>
          </div>
          <div class="border-primary mx-n4 p-4 mt-3 mb-n4 rounded" style="box-shadow: 0 1px 15px rgb(0 0 0 / 18%) !important;">
            <div class="d-flex align-items-center">
              <i class="fas fa-exclamation-triangle text-danger" style="flex: 0 0 32px;"></i>
              <span style="line-height: 1.4">
                Souscrivez un abonnement pour continuer à bénéficier de vos avantages Premium
              </span>
            </div>
            <!-- Select billing plan & number of users -->
            <div class="d-flex align-items-center my-3">
              <span class="mr-2 nobr">Offre : </span>
              <select v-model="trialSelectedPlan" class="form-control">
                <option value="TEAM">TEAM MENSUEL</option>
                <option value="TEAM12M">TEAM ANNUEL</option>
                <option value="BUSINESS">BUSINESS MENSUEL</option>
                <option value="BUSINESS12M">BUSINESS ANNUEL</option>
              </select>
              <span class="mx-2">pour</span>
              <select v-model="trialSelectedUsers" class="form-control">
                <option v-for="nbUsers in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20, 30, 40, 50, 75, 100]" :key="nbUsers" :value="nbUsers">
                  {{ `${nbUsers} ${nbUsers == 1 ? printLang("Pricing.User") : printLang("Pricing.Users") }` }}
                </option>
              </select>
            </div>
            <!-- Subscribe to offer -->
            <div class="d-flex justify-content-center">
              <a class="text-center" :href="`${baseUrl}?plan=${trialSelectedPlan}&users=${trialSelectedUsers}#checkout`">
                <button class="btn btn-round btn-success">Continuer vers le paiement</button>
              </a>
            </div>
          </div>
          <div class="mt-6 d-flex align-items-center">
            <!-- Reset FREE -->
            <i class="fas fa-chevron-double-down" style="flex: 0 0 32px;"></i>
            <div>
              <div class="d-flex align-items-center" style="line-height: 1.4">
                Arrêter l'essai Premium et passer en offre gratuite
                <button :disabled="resetingFree.inprogress" class="btn btn-outline-secondary nobr" @click="resetFreeAccount()">Activer l'offre FREE</button>
              </div>
              <p v-if="resetingFree.error" class="mt-1 alert alert-danger">{{ resetingFree.error }}</p>
            </div>
          </div>
        </div>
        <template v-else-if="hasStripePlan">
          <div v-if="loadingStripeInvoice" class="my-5 text-center">
            <i class="fa fa-spinner fa-spin"></i>
          </div>
          <template v-else>
            <template v-if="hasNextInvoice && ! premiumExpireDateIsPast">
              <!-- active stripe sub -->
              <div class="d-flex align-items-center">
                <i class="fas fa-credit-card" style="flex: 0 0 32px;"></i>
                <span style="line-height: 1.4">Prochain paiement le <b>{{ nextInvoice.date }}</b> de <b>{{ nextInvoice.amount }} TTC</b></span>
              </div>
              <div class="mt-5 text-center">
                <a class="text-center" :href="`${baseUrl}?plan=newcard#checkout`">
                  <button class="btn btn-round btn-primary">Changer de carte bancaire</button>
                </a>
              </div>
              <div class="mt-5 text-center">
                <a href="#" data-toggle="modal" data-target="#myModalSuspendSubscription">
                  Suspendre mon abonnement
                </a>
              </div>
            </template>
            <div v-if="! hasNextInvoice" class="d-flex align-items-center">
              <!-- suspended stripe -->
              <i class="fas fa-credit-card" style="flex: 0 0 32px;"></i>
              <span style="line-height: 1.4">
                Votre abonnement a été suspendu et
                <b :class="premiumExpireDateIsPast ? 'text-danger' : ''">
                  {{ premiumExpireDateIsPast ? 'est arrivé' : 'arrivera' }} à expiration le {{ premiumExpireDate }}
                </b>
              </span>
            </div>
            <div v-if="hasStripeSubscription && premiumExpireDateIsPast" class="my-5">
              <!-- active stripe with payment failure -->
              <div class="d-flex align-items-center text-danger my-5">
                <i class="fas fa-exclamation-triangle" style="flex: 0 0 32px;"></i>
                <span style="line-height: 1.4">
                  <b>Le paiement de votre dernière facture a échoué : votre compte Premium sera bientôt suspendu</b>
                </span>
              </div>
              <div class="mt-5 text-center">
                <a class="text-center" :href="`${baseUrl}?plan=newcard#checkout`">
                  <button class="btn btn-round btn-success">Changer de carte bancaire</button>
                </a>
              </div>
            </div>
            <div v-if="! hasStripeSubscription" class="my-5">
              <!-- suspended stripe -->
              <div class="d-flex align-items-center">
                <i class="fas fa-exclamation-triangle text-danger" style="flex: 0 0 32px;"></i>
                <span style="line-height: 1.4">
                  Votre abonnement a été suspendu, renouvelez-le pour continuer à bénéficier de vos avantages Premium
                </span>
              </div>
              <div class="d-flex justify-content-center pr-6 my-6">
                <a class="text-center" :href="`${baseUrl}?plan=${billingPlan}&users=${premiumMaxUsers}#checkout`">
                  <button class="btn btn-round btn-success">Renouveler mon abonnement</button>
                </a>
              </div>
            </div>
          </template>
        </template>
        <div v-else-if="! hasStripePlan" class="mt-5">
          <!-- custom sub -->
          <div v-if="! premiumExpireDateIsPast" class="d-flex align-items-center">
            <i class="fas fa-star" style="flex: 0 0 32px;"></i>
            <span style="line-height: 1.4">
              Votre abonnement est <b>actif jusqu'au {{ premiumExpireDate }}</b>
            </span>
          </div>
          <div v-else class="d-flex align-items-center text-danger my-5">
            <i class="fas fa-exclamation-triangle" style="flex: 0 0 32px;"></i>
            <span style="line-height: 1.4">
              Votre abonnement est arrivé à expiration le {{ premiumExpireDate }}<br>
              <b>Contactez-nous pour prolonger votre abonnement</b>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL SUSPEND SUSCRIPTION -->
    <div id="myModalSuspendSubscription" class="modal fade" role="dialog">
      <div class="modal-dialog modal-xl">
        <div class="modal-content" style="background-color: #fcfcfc;">
          <!-- CONTACT FORM-->
          <form role="form" action="#" @submit.prevent="suspendSubscription()">
            <div class="modal-header">
              <h5 class="modal-title">Suspendre mon abonnement Premium</h5>
              <button class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="message-text-2" class="control-label">Pour quelle raison souhaitez-vous suspendre votre abonnement ?</label>
                <textarea id="message-text-2" v-model="suspendSubscriptionMessage" required class="form-control" rows="3"></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary mr-2" data-dismiss="modal">Annuler</button>
              <button type="submit" class="btn btn-danger">Suspendre mon abonnement</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- END MODAL SUSPEND SUSCRIPTION -->
    <!-- MODAL SUSPEND SUSCRIPTION CONFIRMATION -->
    <div id="myModalSuspendSubscriptionConfirmation" class="modal fade" data-backdrop="static" role="dialog">
      <div class="modal-dialog modal-xl">
        <div class="modal-content" style="background-color: #fcfcfc;">
          <div class="modal-body text-center mx-auto" style="max-width: 450px;">
            Votre abonnement Premium a bien été annulé et terminera à la fin de la période en cours.
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary mx-auto" data-dismiss="modal" @click="reload">Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- END MODAL SUSPEND SUSCRIPTION CONFIRMATION -->
    <!-- MODAL UNAUTHORIZED MODIFICATION SUSPEND SUBSCRIPTION -->
    <div id="unauthorizedSuspendSubscription" class="modal fade" data-backdrop="static" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Vous n'avez pas les droits nécessaires</h5>
            <button class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Seul un <b>administrateur du compte</b> peut suspendre l'abonnement en cours.<br>
            Merci de vous rapprocher d'un administrateur ou de nous contacter à <a href="mailto:premium@bubbleplan.net">premium@bubbleplan.net</a> en cas d'indisponibilité.
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" data-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- END MODAL UNAUTHORIZED MODIFICATION SUSPEND SUBSCRIPTION -->
  </div>
</template>

<script>
  import { printLang } from '../lang';
  import apiSrv from '../apiSrv';

  export default {
    props: {
      user: { type: Object, required: true },
      subscriptionPromise: { type: Object, required: true },
      availablePlans: { type: Object, required: true },
    },
    data() {
      return {
        printLang,
        loadingStripeInvoice: true,
        nextInvoice: null,
        hasStripeSubscription: null,
        suspendSubscriptionMessage: '',
        hasNextInvoice: null,
        trialSelectedPlan: 'TEAM12M',
        trialSelectedUsers: 10,
        resetingFree: { inprogress: false, error: "" },
      };
    },
    computed: {
      company() { return this.user.company; },
      premiumMaxUsers() { return this.company && this.company.maxusers; },
      premiumMaxConsults() { return this.company && this.company.maxconsults; },
      premiumExpireDate() {
        const date = this.company && this.company.premiumExpireDate && new Date(this.company.premiumExpireDate);
        return date && [date.getDate(), date.getMonth() + 1, date.getFullYear()].map(n => (n < 10 ? `0${n}` : `${n}`)).join('/'); // DD/MM/YYYY
      },
      premiumExpireDateIsPast() {
        const premiumExpireDate = this.company && this.company.premiumExpireDate;
        return premiumExpireDate && (new Date(premiumExpireDate) < new Date(new Date().setHours(0, 0, 0, 0))); // before today 00:00
      },
      billingPlan() { return this.company && this.company.billing_plan; },
      currentPlan() { return this.availablePlans[this.billingPlan]; },
      isTrial() { return this.company && this.company.isTrial; },
      isAdmin() { return this.user && this.user.access_right == 'company_admin'; },
      hasStripePlan() {
        return ['TEAM', 'TEAM12M', 'BUSINESS', 'BUSINESS12M'].includes(this.billingPlan);
      },
      baseUrl() { return printLang('Url'); },
    },
    created() {
      this.loadingStripeInvoice = true;
      this.subscriptionPromise.then((response) => {
        this.hasStripeSubscription = !! (response.subscription && response.subscription.length);
        this.hasNextInvoice = (!! (response.next_invoice && response.next_invoice.date && response.next_invoice.amount));
        this.nextInvoice = response.next_invoice;
        this.loadingStripeInvoice = false;
      });

      this.trialSelectedPlan = this.company.isBusiness ? 'BUSINESS12M' : 'TEAM12M';
    },
    methods: {
      suspendSubscription() {
        $('#myModalSuspendSubscription').modal('hide');
        // send suspend subscription email
        apiSrv.call(window.api.contactmail.url, 'POST', {
          name: "From myaccount premium page.",
          email: "unknown@bubbleplan.net",
          subject: "Suspend subscription",
          message: this.suspendSubscriptionMessage,
        });
        if (this.isAdmin) {
          // cancel plan
          apiSrv.call(`${window.api.buy.url }/plan`, 'DELETE').then(() => {
            $('#myModalSuspendSubscriptionConfirmation').modal('show');
          });
        } else {
          $('#unauthorizedSuspendSubscription').modal('show');
        }
      },
      resetFreeAccount() {
        if (! window.confirm("Vous perdrez l'accès aux fonctionnalités Premium.\nContinuer en offre FREE ?")) return;
        this.resetingFree = { inprogress: true, error: "" };
        apiSrv.call(`${window.api.companies.url}/${this.company.id}/resetfree`, 'GET').then(() => {
          this.reload();
        }).catch((message) => {
          this.resetingFree = { inprogress: false, error: `Erreur : ${message?.responseJSON?.message}` };
        });
      },
      reload() {
        window.location.reload();
      },
    },
  };
</script>
